/* Product page behaviour (sections/msc-main-product.liquid).
   Variant pills (price, availability, ?variant=, hidden id), quantity stepper,
   gallery (thumbs, arrows, dots), and add to bag via /cart/add.js with Dawn's
   cart drawer. Fires `msc:cart-updated` like msc-card.js. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function initGallery(el) {
    var track = el.querySelector('[data-msc-track]');
    if (!track) return;
    var slides = [].slice.call(track.children);
    var thumbs = [].slice.call(el.querySelectorAll('[data-msc-thumb]'));
    var dots = [].slice.call(el.querySelectorAll('[data-msc-dot]'));
    var prev = el.querySelector('[data-msc-prev]');
    var next = el.querySelector('[data-msc-next]');
    var stacked = el.classList.contains('msc-pdp__gallery--stacked');

    function index() {
      var w = slides[0] ? slides[0].getBoundingClientRect().width + 12 : 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }
    function go(i) {
      var s = slides[i];
      if (!s) return;
      if (stacked && window.matchMedia('(min-width: 981px)').matches) {
        s.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: 'smooth' });
    }
    function sync() {
      var i = index();
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= slides.length - 1;
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    /* Product shots in their original order. On the stacked desktop grid a
       variant change puts its shot in the top left slot (the other product
       shots keep their order in the remaining product slots, lifestyle photos
       stay where they are) instead of scrolling the page to it. Elsewhere the
       carousel slides to it. */
    var mediaSlides = slides.filter(function (s) { return s.hasAttribute('data-media-id'); });
    function promote(target) {
      var order = [target].concat(mediaSlides.filter(function (s) { return s !== target; }));
      if (track.querySelector('[data-media-id]') === target) return;
      var k = 0;
      var next = [].slice.call(track.children).map(function (c) {
        return c.hasAttribute('data-media-id') ? order[k++] : c;
      });
      next.forEach(function (c) { track.appendChild(c); });
      slides = next;
      target.classList.remove('is-swapped'); void target.offsetWidth; target.classList.add('is-swapped');
    }
    el.__mscGoToMedia = function (mediaId) {
      var target = null;
      for (var i = 0; i < mediaSlides.length; i++) {
        if (String(mediaSlides[i].getAttribute('data-media-id')) === String(mediaId)) { target = mediaSlides[i]; break; }
      }
      if (!target) return;
      if (stacked && getComputedStyle(track).display === 'grid') { promote(target); return; }
      go(slides.indexOf(target));
    };
    sync();
  }

  function initPdp(sec) {
    var dataEl = sec.querySelector('[data-msc-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) {}
    var gallery = sec.querySelector('[data-msc-gallery]');
    if (gallery) initGallery(gallery);

    /* quantity stepper */
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-msc-qty]');
      if (!b) return;
      var input = b.parentNode.querySelector('input');
      var v = parseInt(input.value, 10) || 1;
      v += parseInt(b.getAttribute('data-msc-qty'), 10);
      input.value = Math.max(1, v);
    });
    sec.addEventListener('change', function (e) {
      if (e.target.matches('[data-msc-qty-input]')) {
        var v = parseInt(e.target.value, 10);
        e.target.value = v > 0 ? v : 1;
      }
    });

    /* variants */
    var pickers = [].slice.call(sec.querySelectorAll('[data-msc-option]'));
    function selected() {
      var out = [];
      pickers.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        out[parseInt(fs.getAttribute('data-msc-option'), 10) - 1] = c ? c.value : null;
      });
      return out;
    }
    function find(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      })[0];
    }
    function update() {
      var opts = selected();
      var v = pickers.length ? find(opts) : variants[0];

      /* grey out values with no available variant given the other choices */
      pickers.forEach(function (fs, pi) {
        [].slice.call(fs.querySelectorAll('.msc-pdp__pill')).forEach(function (pill) {
          var val = pill.querySelector('input').value;
          var test = opts.slice(); test[pi] = val;
          var m = find(test);
          pill.classList.toggle('is-soldout', !!m && !m.available);
        });
        var lab = fs.querySelector('[data-msc-opt-value]');
        if (lab && opts[pi]) lab.textContent = opts[pi];
      });

      var buy = sec.querySelector('[data-msc-buy]');
      var label = sec.querySelector('[data-msc-buy-label]');
      sec.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = v ? v.id : ''; });

      if (v) {
        var p = sec.querySelector('[data-msc-price]');
        if (p) {
          var html = '<span>' + v.price_f + '</span>';
          if (v.compare_f) html += '<s>' + v.compare_f + '</s><span class="msc-badge msc-badge--sale">Sale</span>';
          p.innerHTML = html;
        }
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
        if (gallery && v.media && gallery.__mscGoToMedia) gallery.__mscGoToMedia(v.media);
      }
      if (buy && label) {
        if (!v) { buy.disabled = true; label.textContent = 'Unavailable'; }
        else if (!v.available) { buy.disabled = true; label.textContent = 'Sold out'; }
        else { buy.disabled = false; label.textContent = label.getAttribute('data-default') || 'Add to bag'; }
      }
    }
    pickers.forEach(function (fs) { fs.addEventListener('change', update); });
    if (pickers.length) update();

    /* add to bag */
    var form = sec.querySelector('.msc-pdp__form');
    if (!form) return;
    var msg = form.querySelector('[data-msc-msg]');
    form.addEventListener('submit', function (e) {
      var buy = form.querySelector('[data-msc-buy]');
      if (!buy || buy.disabled || window.__mscPdpBusy) { e.preventDefault(); return; }
      e.preventDefault();
      var id = Number(form.querySelector('input[name="id"]').value);
      var qty = parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
      var drawer = document.querySelector('cart-drawer');
      var item = { id: id, quantity: qty };
      var plan = form.querySelector('input[name="selling_plan"]:checked');
      if (plan && plan.value) item.selling_plan = Number(plan.value);
      var body = { items: [item] };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      if (msg) msg.textContent = '';
      window.__mscPdpBusy = true;
      buy.setAttribute('aria-busy', 'true');
      buy.classList.add('is-loading');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          window.__mscPdpBusy = false;
          buy.removeAttribute('aria-busy'); buy.classList.remove('is-loading');
          if (!res.ok) {
            if (msg) msg.textContent = res.json.description || res.json.message || 'Sorry, we could not add that. Please try again.';
            return;
          }
          fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('msc:cart-updated', { detail: { itemCount: cart.item_count } }));
          }).catch(function () {});
          if (drawer && drawer.renderContents && res.json.sections) {
            var state = res.json; state.id = id;
            drawer.classList.remove('is-empty');
            drawer.renderContents(state);
          } else {
            window.location.href = root + 'cart';
          }
        })
        .catch(function () { window.__mscPdpBusy = false; form.submit(); });
    });
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-msc-pdp]'), function (s) { if (!s.__msc) { s.__msc = 1; initPdp(s); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
